<script lang="ts">
import { nextTick, onBeforeUnmount, onMounted, onScopeDispose, ref, getCurrentInstance } from 'vue';
import { camelCase } from 'lodash-es';

import Confirm, { type ConfirmParams } from '@/components/Popups/Confirm.vue';
// import CommentsPopup, { type CommentsParams } from '@/components/CommentsNew.vue';

// #region Profile
import EditPassword, { type EditPasswordParams } from '@/components/Popups/EditPasswordPopup.vue';
import EditSignificantTtl, { type EditSignificantTtlParams } from '@/components/Popups/EditSignificantTtlPopup.vue';
import EditProfile, { type EditProfileParams } from '@/components/Popups/EditProfilePopup.vue';
//#endregion

// #region Settings
import EditFees, { type EditFeesParams } from '@/views/Settings/components/EditFeesPopup.vue';
import AddCurrency, { type AddCurrencyParams } from '@/views/Settings/components/AddCurrencyPopup.vue';
import AddCountryGroup, { type AddCountryGroupParams } from '@/views/Settings/components/AddCountryGroupPopup.vue';
import AddPaymentMethod, { type AddPaymentMethodParams } from '@/views/Settings/components/AddPaymentMethodPopup.vue';
import AddSystemDomain, { type AddSystemDomainParams } from '@/views/Settings/components/AddSystemDomainPopup.vue';
import CreateToken, { type CreateTokenParams } from '@/views/Settings/components/CreateTokenPopup.vue';
import AddPaymentMethodMediaBuying, { type AddPaymentMethodMediaBuyingParams } from '@/views/Settings/components/AddPaymentMethodMediaBuyingPopup.vue';
import SystemSettings, { type SystemSettingsParams } from '@/components/Popups/SystemSettingsPopup.vue';
//#endregion

//#region affiliates
import TransferAffiliates, { type TransferAffiliatesParams } from '@/views/Affiliates/components/TransferAffiliatesPopup.vue';
import SendNotification, { type SendNotificationPopupParams } from '@/views/Affiliates/components/SendNotificationPopup.vue';
import TrafficBlock from '@/views/Affiliates/Affiliate/components/TrafficBlockPopup.vue';
import CreatePayment, { type CreatePaymentParams } from '@/views/Affiliates/Affiliate/components/CreatePaymentPopup.vue';
import ViewNotification, { type ViewNotificationParams } from '@/views/Affiliates/components/ViewNotificationPopup.vue';
//#endregion

//#region reports
import ReportsFilter, { type ReportsFilterParams } from '@/components/Popups/ReportsFilterPopup.vue';
//#endregion

//#region payments
import CpaConversionDetails, { type CpaConversionDetailsParams } from '@/views/Payments/components/CpaConversionDetailsPopup.vue';
import CpaConversionMoveToHold, { type CpaConversionMoveToHoldParams } from '@/views/Payments/components/CpaConversionMoveToHoldPopup.vue';
import UploadFilesPopup, { type UploadFilesParams } from '@/components/Popups/UploadFilesPopup.vue';
import DeclineExternalPayment, { type DeclineExternalPaymentParams } from '@/views/Payments/components/DeclineExternalPaymentPopup.vue';
import PaymentEstimates, { type PaymentEstimatesParams } from '@/views/Payments/components/PaymentEstimatesPopup.vue';
//#endregion

//#region dashboard
import CloneDashboardPopup, { type CloneDashboardParams } from '@/views/Dashboard/components/CloneDashboardPopup.vue';
import AddDashboardMetricsPopup, { type AddDashboardMetricsParams } from '@/views/Dashboard/components/AddDashboardMetricsPopup.vue';
//#endregion

//#region mediabuying
import BlacklistUrlPopup, { type BlacklistUrlParams } from '@/views/MediaBuying/components/BlacklistUrlPopup.vue';
import BlacklistWalletPopup, { type BlacklistWalletParams } from '@/views/MediaBuying/components/BlacklistWalletPopup.vue';



import PostBlacklistPopup, { type PostBlacklistParams } from '@/views/MediaBuying/components/PostBlacklistPopup.vue';
import CampaignStatisticFilterPopup, { type CampaignStatisticFilterParams } from '@/views/MediaBuying/components/CampaignStatisticFilterPopup.vue';
import MediaBuyingTransferPopup, { type MediaBuyingTransferParams } from '@/views/MediaBuying/components/TransferPopup.vue';
//#endregion

//#region teams
import TeamPopup, { type TeamParams } from '@/views/Teams/components/popups/TeamPopup.vue';
import CreateTeamUser, { type CreateTeamUserParams } from '@/views/Teams/components/popups/CreateTeamUser.vue';
import AttachUserToTeam, { type AttachUserToTeamParams } from '@/views/Teams/components/popups/AttachUserToTeam.vue';
import EditTeamsUser, { type EditTeamsUserParams } from '@/views/Teams/components/popups/EditTeamsUser.vue';
import PinAffiliateUser, { type PinAffiliateUserParams } from '@/views/Teams/components/popups/PinAffiliateUser.vue';
import UserPermissions, { type UserPermissionsParams } from '@/views/Teams/components/popups/UserPermissions.vue';
//#endregion


//#region tools
import RotationGroupPopup, { type RotationGroupParams } from '@/views/Tools/popups/RotationGroupPopup.vue';
import RotationGroupAffiliatesPopup, { type RotationGroupAffiliatesParams } from '@/views/Tools/popups/RotationGroupAffiliatesPopup.vue';
import ServiceDomainPopup, { type ServiceDomainParams } from '@/views/Tools/popups/ServiceDomainPopup.vue';
import BlockedCountriesPopup, { type BlockedCountriesParams } from '@/views/Tools/popups/BlockedCountriesPopup.vue';
import PlatformServerInitScriptPopup, { type PlatformServerInitScriptParams } from '@/views/Tools/popups/PlatformServerInitScriptPopup.vue';
import PlatformServerPopup, { type PlatformServerParams } from '@/views/Tools/popups/PlatformServerPopup.vue';
import DnsHostingAccountPopup, { type DnsHostingAccountParams } from '@/views/Tools/popups/DnsHostingAccountPopup.vue';
import DomainRegistrarAccountPopup, { type DomainRegistrarAccountParams } from '@/views/Tools/popups/DomainRegistrarAccountPopup.vue';
import CreateDedicatedSiteDomainsPopup, { type CreateDedicatedSiteDomainsParams } from '@/views/Tools/popups/CreateDedicatedSiteDomainsPopup.vue';
import PinAffiliateToDomainPopup, { type PinAffiliateToDomainParams } from '@/views/Tools/popups/PinAffiliateToDomainPopup.vue';
import LandingMatchPopup, { type LandingMatchParams } from '@/views/Tools/popups/LandingMatchPopup.vue';
import MarketingMaterialPopup, { type MarketingMaterialParams } from '@/views/Tools/popups/MarketingMaterialPopup.vue';
//#endregion

//#region players
import TransferPlayers, { type TransferPlayersParams } from '@/views/Players/components/TransferPlayersPopup.vue';
import LinkAffiliate, { type LinkAffiliateParams } from '@/views/Players/components/LinkAffiliatePopup.vue';
import MarkPlayerVirtual, { type MarkPlayerVirtualParams } from '@/views/Players/components/MarkPlayerVirtualPopup.vue';
//#endregion

// #region CRM
import ActivityMetrics, { type ActivityMetricsParams } from '../views/CRM/components/popups/ActivityMetricsPopup.vue';
import TemplateMailAction, { type TemplateMailActionParams } from '../views/CRM/components/popups/TemplateMailActionPopup.vue';
import CreateSegment, { type CreateSegmentParams } from '../views/CRM/components/popups/CreateSegment.vue';
import ViewSegmentPopup, { type ViewSegmentParams } from '../views/CRM/components/popups/ViewSegmentPopup.vue';
import AddSmsAction, { type AddSmsActionParams } from '../views/CRM/components/popups/AddSmsActionPopup.vue';
import AddSmsActionPreview, { type AddSmsActionPreviewParams } from '../views/CRM/components/popups/AddSmsActionPreviewPopup.vue';
import AddMailAction, { type AddMailActionParams } from '../views/CRM/components/popups/AddMailActionPopup.vue';
import AddMailActionPreview, { type AddMailActionPreviewParams } from '../views/CRM/components/popups/AddMailActionPreviewPopup.vue';
import AddCallCenterAction, { type AddCallCenterActionParams } from '../views/CRM/components/popups/AddCallCenterActionPopup.vue';
import AddPushAction, { type AddPushActionParams } from '../views/CRM/components/popups/AddPushActionPopup.vue';
import ConfirmSendTestEmail, { type ConfirmSendTestEmailParams } from '../views/CRM/components/popups/ConfirmSendTestEmail.vue';
import ConfirmSendTestSms, { type ConfirmSendTestSmsParams } from '../views/CRM/components/popups/ConfirmSendTestSms.vue';
// #endregion

const popupsRegistry = [
  { Confirm, ...$<ConfirmParams>() },
  { EditPassword, ...$<EditPasswordParams>() },
  { EditSignificantTtl, ...$<EditSignificantTtlParams>() },
  { EditProfile, ...$<EditProfileParams>() },
  { EditFees, ...$<EditFeesParams>() },
  { AddCurrency, ...$<AddCurrencyParams>() },
  { AddCountryGroup, ...$<AddCountryGroupParams>() },
  { AddPaymentMethod, ...$<AddPaymentMethodParams>() },
  { AddSystemDomain, ...$<AddSystemDomainParams>() },
  { CreateToken, ...$<CreateTokenParams>() },
  { AddPaymentMethodMediaBuying, ...$<AddPaymentMethodMediaBuyingParams>() },
  { SystemSettings, ...$<SystemSettingsParams>() },
  { TrafficBlock, ...$<PopupPayload>() }, // TODO: исправить на правильный тип
  { CreatePayment, ...$<CreatePaymentParams>() },
  { ReportsFilter, ...$<ReportsFilterParams>() },
  { CpaConversionDetails, ...$<CpaConversionDetailsParams>() },
  { CloneDashboardPopup, ...$<CloneDashboardParams>() },
  { AddDashboardMetricsPopup, ...$<AddDashboardMetricsParams>() },
  { TransferAffiliates, ...$<TransferAffiliatesParams>() },
  { SendNotification, ...$<SendNotificationPopupParams>() },
  { ViewNotification, ...$<ViewNotificationParams>() },
  { CpaConversionMoveToHold, ...$<CpaConversionMoveToHoldParams>() },
  { BlacklistUrlPopup, ...$<BlacklistUrlParams>() },
  { BlacklistWalletPopup, ...$<BlacklistWalletParams>() },
  // { CommentsPopup, ...$<CommentsParams>() },
  { PostBlacklistPopup, ...$<PostBlacklistParams>() },
  { CampaignStatisticFilterPopup, ...$<CampaignStatisticFilterParams>() },
  { MediaBuyingTransferPopup, ...$<MediaBuyingTransferParams>() },
  { PaymentEstimates, ...$<PaymentEstimatesParams>() },
  { TeamPopup, ...$<TeamParams>() },
  { CreateTeamUser, ...$<CreateTeamUserParams>() },
  { AttachUserToTeam, ...$<AttachUserToTeamParams>() },
  { EditTeamsUser, ...$<EditTeamsUserParams>() },
  { PinAffiliateUser, ...$<PinAffiliateUserParams>() },
  { UserPermissions, ...$<UserPermissionsParams>() },
  { UploadFilesPopup, ...$<UploadFilesParams>()},
  { DeclineExternalPayment, ...$<DeclineExternalPaymentParams>() },
  { RotationGroupPopup, ...$<RotationGroupParams>() },
  { RotationGroupAffiliatesPopup, ...$<RotationGroupAffiliatesParams>() },
  { ServiceDomainPopup, ...$<ServiceDomainParams>() },
  { BlockedCountriesPopup, ...$<BlockedCountriesParams>() },
  { PlatformServerInitScriptPopup, ...$<PlatformServerInitScriptParams>() },
  { PlatformServerPopup, ...$<PlatformServerParams>() },
  { DnsHostingAccountPopup, ...$<DnsHostingAccountParams>() },
  { DomainRegistrarAccountPopup, ...$<DomainRegistrarAccountParams>() },
  { CreateDedicatedSiteDomainsPopup, ...$<CreateDedicatedSiteDomainsParams>() },
  { PinAffiliateToDomainPopup, ...$<PinAffiliateToDomainParams>() },
  { LandingMatchPopup, ...$<LandingMatchParams>() },
  { MarketingMaterialPopup, ...$<MarketingMaterialParams>() },
  { CreateSegment, ...$<CreateSegmentParams>() },
  { ViewSegmentPopup, ...$<ViewSegmentParams>() },
  { ActivityMetrics, ...$<ActivityMetricsParams>() },
  { AddSmsAction, ...$<AddSmsActionParams>() },
  { AddSmsActionPreview, ...$<AddSmsActionPreviewParams>() },
  { AddMailAction, ...$<AddMailActionParams>() },
  { TemplateMailAction, ...$<TemplateMailActionParams>() },
  { AddMailActionPreview, ...$<AddMailActionPreviewParams>() },
  { AddCallCenterAction, ...$<AddCallCenterActionParams>() },
  { AddPushAction, ...$<AddPushActionParams>() },
  { ConfirmSendTestEmail, ...$<ConfirmSendTestEmailParams>() },
  { ConfirmSendTestSms, ...$<ConfirmSendTestSmsParams>() },
  { TransferPlayers, ...$<TransferPlayersParams>() },
  { LinkAffiliate, ...$<LinkAffiliateParams>() },
  { MarkPlayerVirtual, ...$<MarkPlayerVirtualParams>() },
] as const satisfies ComponentEntry[];

function $<T>() {
  return {
    params: {} as T,
  };
}

type ComponentEntry<
  P = any,
  C extends abstract new (...args: any) => any = abstract new (...args: any) => any,
> = {
  params: P;
} & {
  [key: string]: C | P;
};

type ExtractComponents<T extends readonly any[]> = {
  [K in T[number] as keyof Omit<K, 'params'>]: K[keyof Omit<K, 'params'>]
};

type ExtractComponentKey<T> = keyof Omit<T, 'params'>;

type CombinedTypeFromRaw<T extends readonly any[]> = {
  [K in T[number] as Uncapitalize<ExtractComponentKey<K> & string>]: PopupType<
    K['params'],
    K[ExtractComponentKey<K>]
  >;
};

const componentsRaw = popupsRegistry.reduce((acc, item) => {
  const [key] = Object.keys(item).filter((k) => k !== 'params');
  return { ...acc, [key!]: item[key as keyof typeof item] };
}, {} as ExtractComponents<typeof popupsRegistry>);


type CombinedType = CombinedTypeFromRaw<typeof popupsRegistry> & {
  $scopeDispose: () => void,
};

export type PopupOpenHandler<Params extends PopupPayload> = (payload: Params, existBehaviour?: ExistBehaviour) => any;

export interface PopupType<Params, ComponentName extends abstract new (...args: any) => any> {
  open: (payload: Params, existBehaviour?: ExistBehaviour) => Promise<InstanceType<ComponentName>>;
}

export interface ExistBehaviour {
  key?: string;
  onExist?: () => {};
  disableScroll?: boolean;
  dontCloseOnUnmounted?: boolean;
}

export interface PopupPayload {
  data?: {[key: string]: any},
  listeners?: {[key: string]: any},
}

interface PopupPayloadExtra extends PopupPayload {
  promiseCb?: (el: abstract new (...args: any) => any) => void,
  savedData?: any;
}

interface PopupMeta extends PopupPayload {
  id: number;
  component: string;
  key?: string,
  existBehaviour?: ExistBehaviour,
  promiseCb?: (el: abstract new (...args: any) => any) => void,
}

const componentsRawKeys = Object.keys(componentsRaw) as Array<keyof typeof componentsRaw>;
const components: any = {};
const popupManager: any = {};
componentsRawKeys.forEach((key) => {
  const componentKey = `${key}Popup`;
  components[componentKey] = componentsRaw[key];
  popupManager[camelCase(key)] = {
    open(payload: any, existBehaviour?: ExistBehaviour) {
      const dontCloseOnUnmounted = existBehaviour && existBehaviour.dontCloseOnUnmounted;
      let cb;
      const promise = new Promise((resolve) => {
        cb = (component: any) => {
          if (!dontCloseOnUnmounted) {
            if (this.$unmountParams) {
              this.$unmountParams.cbList.push(() => {
                return component.$.vnode.key;
              });
            }
          }

          if (component.fetchData) {
            if (!this.$popupData[key]) {
              component.fetchData().then((savedData: any) => {
                this.$popupData[key] = savedData;
              });
            }
          }

          resolve(component);
        };
      });

      const savedData = this.$popupData[key] ? { savedData: this.$popupData[key] } : {};

      const newPayload = {
        ...payload,
        ...savedData,
        promiseCb: cb,
      };

      eventBus.$emit('open-popup', componentKey, newPayload, existBehaviour);

      return promise;
    },
  };
});

export const usePopupManager = (): CombinedType => {
  const unmountParams = {
    cbList: [] as (() => number)[],
  };

  const scopeDispose = () => {
    const idsToClose = unmountParams.cbList.map((cb) => cb());
    eventBus.$emit('close-popups', idsToClose);
  };

  onScopeDispose(() => {
    scopeDispose();
  });

  const result: any = {
    $unmountParams: unmountParams,
    $popupData: {},
    $scopeDispose: scopeDispose,
  };

  const keys = Object.keys(popupManager as CombinedType);
  keys.forEach((key) => {
    result[key] = {
      ...popupManager[key],
      open: popupManager[key].open.bind(result),
    };
  });

  return result;
};

export default {
  components,
};
</script>

<script setup lang="ts">
import eventBus from '@/setup/eventBus';
import { useTicket } from '@/composables/useTicket';

const { createTicketCounter } = useTicket();

const popups = ref<PopupMeta[]>([]);
const popupRefs = ref<any>([]);

const getNextKey = createTicketCounter();

const popupRefsHandler = (el: any, index: number) => {
  if (el) {
    popupRefs.value[index] = el;

    const popup = popups.value[index];
    if(popup && popup.promiseCb) {
      popup.promiseCb(el);
    }
  } else {
    popupRefs.value[index] = null;
  }
};

function handleOpenConfirm(component: string, payload: PopupPayloadExtra = {}, existBehaviour: ExistBehaviour = {}) {
  const { key, onExist, disableScroll } = existBehaviour;
  if (key) {
    const isExist = popups.value.some((item) => item.key === key);
    if (isExist) {
      if (onExist && typeof onExist === 'function') {
        onExist();
      }
      return;
    }
  }

  const id = getNextKey();
  const { data, listeners, promiseCb, savedData } = payload;
  const combinedData = savedData
    ? {
      ...data,
      savedData,
    }
    : data;
  const confirmData: PopupMeta = {
    id,
    component,
    data: combinedData || {},
    listeners: listeners || {},
    key: key,
    existBehaviour: existBehaviour,
    promiseCb,
  };

  popups.value.push(confirmData);

  nextTick(() => {
    const popup = popupRefs.value.find((ref: any) => {
      return ref.$.vnode.key === id;
    });

    if (popup) {
      if (disableScroll) {
        const body = document.querySelector('body')!;
        body.classList.add('body_scroll-disabled');
      }

      popup.open();
    }
  });
};

function handleClose(index: number) {
  const popup = popups.value[index];

  if (popup) {
    if (popup.existBehaviour) {
      const body = document.querySelector('body')!;
      body.classList.remove('body_scroll-disabled');
    }

    popups.value.splice(index, 1);
  }
};

function handleCloseMany(ids: number[]) {
  let removeScrollDisabled = false;
  ids.forEach((id) => {
    const popup = popups.value.find((item) => item.id === id);

    if (popup?.existBehaviour) {
      removeScrollDisabled = true;
    }
  });

  popups.value = popups.value.filter((popup) => !ids.includes(popup.id));

  if(removeScrollDisabled) {
    const body = document.querySelector('body')!;
    body.classList.remove('body_scroll-disabled');
  }
};

onMounted(() => {
  eventBus.$on('open-popup', handleOpenConfirm);
  eventBus.$on('close-popups', handleCloseMany);
});

onBeforeUnmount(() => {
  eventBus.$off('open-popup', handleOpenConfirm);
  eventBus.$off('close-popups', handleCloseMany);
});
</script>

<template>
  <div
    v-if="popups.length"
    class="popup-manager"
  >
    <component
      :is="popup.component"
      v-for="(popup, index) in popups"
      :key="popup.id"
      :ref="(el: any) => popupRefsHandler(el, index)"
      v-bind="popup.data"
      v-on="popup.listeners"
      @close="handleClose(index)"
    />
  </div>
</template>
